import { useDirectory } from "../lib/directory";

/**
 * Compact assignee dropdown fed by the live team directory (pipeline-users
 * merged with the hardcoded seed). Shows initials when assigned, an
 * outlined "+" when not.
 */
export default function AssigneePicker({
  assigneeEmail,
  assigneeName,
  onChange,
}: {
  assigneeEmail: string | null;
  assigneeName: string | null;
  onChange: (assignee: { email: string; displayName: string } | null) => void;
}) {
  const directory = useDirectory();
  const initials = assigneeName
    ? assigneeName
        .split(" ")
        .map((p) => p[0])
        .slice(0, 2)
        .join("")
    : null;
  const photoURL = assigneeEmail
    ? (directory.find((t) => t.email === assigneeEmail.toLowerCase())?.photoURL ?? null)
    : null;

  return (
    <div className="relative inline-flex items-center" title={assigneeName ?? "Unassigned"}>
      <select
        value={assigneeEmail ?? ""}
        onChange={(e) => {
          const member = directory.find((t) => t.email === e.target.value);
          onChange(member ? { email: member.email, displayName: member.displayName } : null);
        }}
        className="absolute inset-0 cursor-pointer opacity-0"
        aria-label="Assignee"
      >
        <option value="">Unassigned</option>
        {directory.map((t) => (
          <option key={t.email} value={t.email}>
            {t.displayName}
          </option>
        ))}
      </select>
      {photoURL ? (
        <img
          src={photoURL}
          alt={assigneeName ?? ""}
          referrerPolicy="no-referrer"
          className="pointer-events-none h-6 w-6 rounded-full object-cover"
        />
      ) : initials ? (
        <span className="pointer-events-none flex h-6 w-6 items-center justify-center rounded-full bg-ink font-mono text-[9px] font-semibold text-white">
          {initials}
        </span>
      ) : (
        <span className="pointer-events-none flex h-6 w-6 items-center justify-center rounded-full border border-dashed border-line-strong font-mono text-[11px] text-faint">
          +
        </span>
      )}
    </div>
  );
}
